import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faFilePdf,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import FilterContext from "../../../routes/FilterContext";
import Table from "react-bootstrap/Table";
import {
  BodyAsFormData,
  encodedUrlBuliding,
} from "../../../services/utilities/util";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import md5 from "md5";
import { Link } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { downloadPdf } from "../../../services/utilities/util";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class TopOccupiersTableOwner extends React.Component {
  static contextType = FilterContext;

  state = {
    topOccupiers: [],
    filters: "",
    showLoader: false,
    showGraph: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_owner_top_occupiers", BodyAsFormData(filters))
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        this.setState({ topOccupiers: res.data.splice(0, 10) });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      apiMiddleware
        .post(
          "api/edge/office/get_owner_top_occupiers",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          this.setState({
            topOccupiers: res.data.splice(0, 10),
          });
        });
    }
  }

  render() {
    return (
      <div className="widget widgetTable">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Top 10 Occupiers</p>
            </div>
            <div className="col-lg-3 text-end">
              <p className="colorBlack downloads">
                <FontAwesomeIcon icon={faEllipsisV} />
                <ul className="downloadOptions">
                  <li className="excelDownload">
                    <ReactHTMLTableToExcel
                      id="topOccupiersTableXlsButton"
                      className="download-table-xls-button"
                      table="topOccupiers"
                      filename="topOccupiers"
                      sheet="topOccupiers"
                      buttonText={"Download as Excel"}
                    />
                  </li>
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      downloadPdf("#topOccupiers", "topOccupiers");
                    }}
                  >
                    Download as PDF <FontAwesomeIcon icon={faFilePdf} />
                  </li>
                </ul>
              </p>
            </div>
            <div className="col-lg-12 mt-2">
              <Table responsive hover id="topOccupiers">
                <thead>
                  <tr className="">
                    <th>Occupier Name</th>
                    <th>Area Leased</th>
                    <th>Wt. Avg. Current Rent.</th>
                    <th>WALE</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.topOccupiers.length > 0 &&
                    this.state.topOccupiers.map((row, i) => (
                      <tr className="tableTdColor" key={i}>
                        <td title={row.tenant}>
                          <Link
                            target="_blank"
                            to={encodedUrlBuliding("tenant", row.tenant)}
                          >
                            {row.tenant}
                          </Link>
                        </td>
                        <td>{row.area}</td>
                        <td>{row.current_passing_rent}</td>
                        <td>{row.wale}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(TopOccupiersTableOwner);
